import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { AppConfigService } from '@tmhcc-ng-lib/global-services';
import { BaseDataService } from './base-data-service';
import {
  DashboardRequest,
  DashboardResponse,
  ApprovedRequestPost,
  ApprovedRequestPayment,
  ClaimDashBoardMetrics,
  AgencyLossRunRequest,
  AgencyLossRunResponse,
  BoundPolicyReportResponse,
  BoundPolicyReportRequest,
  DashboardAdvancedSearchRequest
} from './def/get-dashboard';
import { GlobalVariablesService } from './global-variables.service';

@Injectable()
export class DashboardService extends BaseDataService {
  constructor(
    protected http: HttpClient,
    protected configService: AppConfigService,
    protected globalVariables: GlobalVariablesService
  ) {
    super(http, configService, globalVariables);
  }

  getDashboardActionData(
    subCompanyCode: string
  ): Observable<DashboardResponse> {
    const payload: DashboardRequest = { SubCompanyCode: subCompanyCode };
    const url = `${this.serviceBaseUrl}/policies/${payload.SubCompanyCode}/action-required`;
    return this.get<DashboardResponse>(url);
  }
  getDashboardUpcomingData(
    subCompanyCode: string
  ): Observable<DashboardResponse> {
    const payload: DashboardRequest = { SubCompanyCode: subCompanyCode };
    const url = `${this.serviceBaseUrl}/policies/${payload.SubCompanyCode}/upcoming-renewals`;
    return this.get<DashboardResponse>(url);
  }
  getDashboardSubjectivityData(
    subCompanyCode: string
  ): Observable<DashboardResponse> {
    const payload: DashboardRequest = { SubCompanyCode: subCompanyCode };
    const url = `${this.serviceBaseUrl}/policies/${payload.SubCompanyCode}/open-subjectivities`;
    return this.get<DashboardResponse>(url);
  }
  getDashboardPendingData(
    subCompanyCode: string
  ): Observable<DashboardResponse> {
    const payload: DashboardRequest = { SubCompanyCode: subCompanyCode };
    const url = `${this.serviceBaseUrl}/policies/${payload.SubCompanyCode}/pending-transactions`;
    return this.get<DashboardResponse>(url);
  }
  getDashboardBoundData(subCompanyCode: string): Observable<DashboardResponse> {
    const payload: DashboardRequest = { SubCompanyCode: subCompanyCode };
    const url = `${this.serviceBaseUrl}/policies/${payload.SubCompanyCode}/bound-policies`;
    return this.get<DashboardResponse>(url);
  }  
  getDashboardAdvancedSearchData(subCompanyCode: string,insuredName: string,policyIdentifier: string    
  ): Observable<DashboardResponse> {
    const url = `${this.serviceBaseUrl}/policies/advanced-search`;
    const payload: DashboardAdvancedSearchRequest = { AgencyId: subCompanyCode, InsuredName:insuredName, PolicyIdentifier: policyIdentifier };
    //const url = `http://localhost:51806/policies/advancedSearchCriteria`;
    return this.post<DashboardResponse>(url, { body: payload }, false);
  }
  DashboardApprove(params: ApprovedRequestPost): Observable<any> {
    const url = `${this.serviceBaseUrl}/BulkApproveOrRejectReserve`;
    return this.post<ApprovedRequestPost>(url, { body: params }, true);
  }

  DashboardPaymentApproveOrReject(
    params: ApprovedRequestPayment
  ): Observable<any> {
    const url = `${this.serviceBaseUrl}/BulkApproveRejectPayment`;
    return this.post<ApprovedRequestPost>(url, { body: params }, true);
  }

  ClaimDashBoardMetrics(params: ClaimDashBoardMetrics): Observable<any> {
    const url = `${this.serviceBaseUrl}/ClaimDashboardMetrics`;
    return this.post<ClaimDashBoardMetrics>(url, { body: params }, false);
  }

  agencyLossRun(
    params: AgencyLossRunRequest
  ): Observable<AgencyLossRunResponse> {
    const url = `${this.serviceBaseUrl}/infinity/get-agency-policy-claims-loss-run/${params.AgencyContactId}/${params.SubCompanyCode}`;
    return this.get<AgencyLossRunResponse>(url);
  }

  boundPolicyReport(
    params: BoundPolicyReportRequest
  ): Observable<BoundPolicyReportResponse> {
    const url = `${this.serviceBaseUrl}/infinity/get-casualty-bound-policies`;
    return this.post<BoundPolicyReportResponse>(url, { body: params }, false);
  }

}
